import apiService from '@/services/apiService';

const actions = {
  getOnBoardingScreens({ commit }) {
    return new Promise((resolve, reject) => {
      apiService.get('onboarding-screen')
        .then((response) => {
          commit('getOnBoardingScreens', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getOnBoardingScreen({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.get(`onboarding-screen/${payload}`)
        .then((response) => {
          resolve(response.data.data);
          commit('getOnBoardingScreen', response.data.data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getSlideScreen({ commit }, payload) {
    apiService.post('onboarding-screen/check-availability-slide-screen-before-create', payload)
      .then((response) => {
        commit('getSlideScreen', response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  getSlideScreenEdit({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('onboarding-screen/check-availability-slide-screen-before-update', payload)
        .then((response) => {
          resolve(response.data.data);
          commit('getSlideScreen', response.data.data);
        })
        .catch((error) => {
          reject(error);
          console.log(error);
        });
    });
  },
  postOnBoardingScreen({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('onboarding-screen', payload)
        .then((response) => {
          commit('postOnBoardingScreen', payload);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateOnBoardingScreens({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('onboarding-screen/update-status', payload)
        .then((response) => {
          const object = {};
          payload.forEach((value, key) => { object[key] = value; });
          const json = JSON.stringify(object);
          commit('updateOnBoardingScreens', json);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putOnBoardingScreen({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`onboarding-screen/${payload.id}`, payload.formData)
        .then((response) => {
          commit('putOnBoardingScreen', payload);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  delOnBoardingScreen({ commit }, payload) {
    apiService.delete(`onboarding-screen/${payload}`)
      .then((response) => {
        commit('delOnBoardingScreen', payload);
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
  },

};

export default actions;
